import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-hearing-request-dialog',
	templateUrl: './hearing-request-dialog.component.html',
	styleUrls: ['./hearing-request-dialog.component.scss']
})
export class HearingRequestDialogComponent {
	@Input() visible = false;
	@Input() message = '';
	@Input() hearingUrl = '';
	@Input() curentLang = 'en';
	@Output() visibleChange = new EventEmitter<boolean>();

	constructor(private translate: TranslateService) {}

	closeDialog() {
		this.visible = false;
		this.visibleChange.emit(false);
	}

	async openHearingUrl() {
		if (!this.hearingUrl) {
			this.closeDialog();
			return;
		}

		const confirmResult = await Swal.fire({
			title: this.translate.instant('hearingRequest.confirmTitle'),
			text: this.translate.instant('hearingRequest.confirmText'),
			icon: 'info',
			showCancelButton: true,
			confirmButtonColor: '#28a745',
			cancelButtonColor: '#6c757d',
			confirmButtonText: this.translate.instant('hearingRequest.confirmYes'),
			cancelButtonText: this.translate.instant('hearingRequest.confirmNo'),
		});

		if (confirmResult.isConfirmed) {
			window.open(this.hearingUrl, '_blank', 'noopener,noreferrer');
		}

		this.closeDialog();
	}
}
